import { useAuth0 } from "@auth0/auth0-react";
import SearchAutoComplete from "components/SearchAutoComplete";
import SearchDownShift from "components/downmshift/DownShift";
import { useFormik } from "formik";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from "react-router-dom";
import FinanceSettingService from "../../../../Lib/API/FinanceSetting/FinanceSetting";
import NotAuthorized from "../../../../components/NotAuthorized";
import SearchComp from "../../../../components/Searchcomponent";
import SettingHeader from "../../SettingHeader/settingHEader";
import ComponentHeading from "../../componentHeading/ComponentHeading";
import LeftMenu from "../../leftMenu/LeftMenu";
const AccountBillingTypeView = ({ heading }) => {
  const { push } = useHistory();
  const [type, setType] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const [disable, setDisable] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [disableAddNew, setDaisableAddNew] = useState(false);
  const [edit, setEdit] = useState(false);
  const [addPath, setAddPath] = useState();
  const [accountBillingTypes, setAccountBillingTypes] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [accountBillingData, setAccountBillingData] = useState({});
  const [accountBillingId, setAccountBillingId] = useState("");
  const [fieldsOnDelete, setFieldsOnDelete] = useState(false);
  const [IsSettingsActive, setIsSettingsActive] = useState(true);
  const formik = useFormik({
    enableReinitialize: true,

    initialValues:
      addNew === true
        ? {
          statement_message: "",
          batch_billing_amount: "",
          billing_type_name: "",
        }
        : {
          billing_type_name:
            accountBillingData?.title ?? accountBillingTypes[0]?.title ?? "",
          statement_message:
            accountBillingData?.statement_message ??
            accountBillingTypes[0]?.statement_message ??
            "",
          batch_billing_amount:
            accountBillingData?.batch_amount ??
            accountBillingTypes[0]?.batch_amount ??
            "",
        },
  });
  const initialSatge = () => {
    formik.setFieldValue("billing_type_name", accountBillingTypes[0]?.title);
    formik.setFieldValue(
      "statement_message",
      accountBillingTypes[0]?.statement_message
    );
    formik.setFieldValue(
      "batch_billing_amount",
      accountBillingTypes[0]?.batch_amount
    );
  };
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.includes("view")) {
      setEdit(false);
      setDaisableAddNew(false);
      setDisable(false);
      setAddNew(false);
    }
  }, [pathname]);

  // Get Account Billing Types List
  const fetchAccountBillingTypes = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getAccountBillingTypes(token).then((res) => {
      setAccountBillingTypes(res?.result);
      setType(res?.result[0]?.title);
    });
  };
  // Get Account Billing Types List By Id
  const getAccountBliingListById = async (type, id) => {
    setFieldsOnDelete(false);
    setType(type);
    setAccountBillingId(id);
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getAccountBillingTypesById(id, token).then(
      (res) => {
        setAccountBillingData(res?.result);
      }
    );
  };
  // update Account Billing Type
  const updateAccountBillingType = async () => {
    if (
      formik.values?.billing_type_name == "" ||
      !formik.values?.billing_type_name.match(
        /^(?![\s-])[\w\s-+]+$/,
        "Enter a valid name"
      )
    ) {
      toastr.error("error", "Please enter a valid billing type");
    } else {
      setFieldsOnDelete(false);
      const token = await getAccessTokenSilently();
      await FinanceSettingService.updateAccountBillingById(
        accountBillingId || accountBillingTypes[0]?._id,
        formik.values?.statement_message != ""
          ? {
            title: formik.values?.billing_type_name,
            batch_amount: formik.values?.batch_billing_amount,
            amount_type: "$",
            statement_message: formik.values?.statement_message,
          }
          : {
            title: formik.values?.billing_type_name,
            batch_amount: formik.values?.batch_billing_amount,
            amount_type: "$",
          },
        token
      )
        .then(() => {
          toastr.success("Success", "Revesal Type has been updated");
          push({
            pathname: "/financial-setting/account-billing-types/view",
          });
        })
        .catch((error) => {
          toastr.error("Update Error", error?.data?.message ?? "Some fields are missing");
        });
      fetchAccountBillingTypes();
      initialSatge();
    }
  };
  // Disable A Account Billing type
  const deletAccountBillingById = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.deleteAccountBillingById(
      accountBillingId || accountBillingTypes[0]?._id,
      token
    ).then((res) => {
      if (res) {
        setFieldsOnDelete(true);
        fetchAccountBillingTypes();
      }
    });
    initialSatge();
  };

  // Create A New Account Billing Type
  const createAccountBillingType = async () => {
    if (
      formik.values?.billing_type_name == "" ||
      !formik.values?.billing_type_name.match(
        /^(?![\s-])[\w\s-+]+$/,
        "Enter a valid name"
      )
    ) {
      toastr.error("error", "Please enter a valid billing type");
    } else {
      const token = await getAccessTokenSilently();
      await FinanceSettingService.createNewAccountBillingType(
        formik.values?.statement_message != ""
          ? {
            title: formik.values?.billing_type_name,
            batch_amount: formik.values?.batch_billing_amount,
            amount_type: "$",
            statement_message: formik.values?.statement_message,
          }
          : {
            title: formik.values?.billing_type_name,
            batch_amount: formik.values?.batch_billing_amount,
            amount_type: "$",
          },
        token
      )
        .then(() => {
          toastr.success("Success", "New Account has been created");
          setFieldsOnDelete(true);
        })
        .catch((e) => {
          toastr.error(e?.data?.message ?? "Error");
        });
      fetchAccountBillingTypes();
    }
  };
  const option2 = accountBillingTypes?.map((item, index) => ({
    id: item?._id,
    name: item?.title,
  }));
  const debounceSearch = useCallback(
    debounce(async () => {
      if (searchValue) {
        const token = await getAccessTokenSilently();
        await FinanceSettingService.searchAccountBillingType(
          searchValue,
          token
        ).then((res) => {
          setAccountBillingTypes(res.result);
        });
      }
    }, 1000),
    [searchValue]
  );
  useEffect(() => {
    if (searchValue === "") {
      fetchAccountBillingTypes();
    } else {
      setSearchValue(searchValue);
    }
  }, [searchValue]);
  useEffect(() => {
    debounceSearch();
    return () => {
      debounceSearch.cancel();
    };
  }, [debounceSearch, searchValue]);
  useEffect(() => {
    fetchAccountBillingTypes();
  }, []);

  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "financial setting") {
        return setIsSettingsActive(item?.active);
      }
    });
  }, []);

  return IsSettingsActive == false ? (
    <NotAuthorized title={"Reports"} />
  ) : (
    <div className="w-100">
      <SettingHeader
        heading={heading}
        edit={edit}
        addNew={addNew}
        path={"/financial-setting/account-billing-types/view"}
        setAddNew={setAddNew}
        parentHeading={"Financial"}
        alertOnEdit={edit}
      />
      <div className="main-setting__wrapper">

        <div className="col-md-4 mb-5 pl-7 pr-7">
          <SearchDownShift
            items={option2}
            name={searchValue}
            setName={setSearchValue}
            placeHolder="Search"
            autoFocus
          />
        </div>
        <div className="setting-main">
          <div className="left-menu-div">
            <LeftMenu
              types={accountBillingTypes}
              getTypeId={getAccountBliingListById}
              btnText={"New Billing Type"}
              disableAddNew={disableAddNew}
              setAddNew={setAddNew}
              setDisable={setDisable}
              setDaisableAddNew={setDaisableAddNew}
              addPath={addPath}
            />
          </div>
          <div className="settings-details asdfasdf">
            <ComponentHeading
              type={formik.values?.billing_type_name ?? type}
              heading={heading}
              addNew={addNew}
              disable={disable}
              setDaisableAddNew={setDaisableAddNew}
              setDisable={setDisable}
              edit={edit}
              setEdit={setEdit}
              setAddPath={setAddPath}
              formik={formik}
              deleteFunc={deletAccountBillingById}
              updateFunc={updateAccountBillingType}
              createFunc={createAccountBillingType}
              setAddNew={setAddNew}
            />
          </div>
        </div>
      </div>
    </div>

  );
};

export default AccountBillingTypeView;
